import React from "react";
import { Button, Collapse, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { IconButton } from "./";
const { Panel } = Collapse;

export const WelcomePanel = ({ scenarioAdd, close }) => {
  return (
    <div className="scenario">
      <div className="scenario__header">
        <div className="scenario__header-cell scenario__header-cell--label">
          <h1 className="scenario__heading-label">Welcome</h1>
        </div>

        <div className="scenario__header-cell">
          <IconButton onClick={close}>
            <Tooltip
              placement="left"
              arrowPointAtCenter
              title="Dismiss welcome message"
            >
              <CloseOutlined />
            </Tooltip>
          </IconButton>
        </div>
      </div>

      <div className="scenario__content">
        <div className="scenario__intro">
          <p>
            Tree Equity Score Analyzer (TESA) helps you plan and analyze tree
            planting scenarios with the goal of improving{" "}
            <a href="https://treeequityscore.org/">Tree Equity</a>.
          </p>
          <Collapse ghost>
            <Panel header="Learn how to get started" key="1">
              <ol className="ordered-list">
                <li className="ordered-list__item">
                  Use the indicators and filters to find locations and
                  priorities for your tree planting
                </li>
                <li className="ordered-list__item">
                  Choose the scale you would like to work in. Block group
                  scenarios are more for seeing how much more canopy you need to
                  achieve a tree equity goal. Parcel scenarios are more for
                  targeted planting of trees.
                </li>
                <li className="ordered-list__item">
                  If needed draw custom boundaries for areas like public
                  rights-of-way
                </li>
                <li className="ordered-list__item">
                  Choose how much tree canopy you want to add to each site
                </li>
                <li className="ordered-list__item">
                  Pick the type and size of the trees to plant
                </li>
                <li className="ordered-list__item">
                  Export an impact report or share the URL
                </li>
                <li className="ordered-list__item">
                  Login and edit your scenario at any time
                </li>
              </ol>
            </Panel>
          </Collapse>
          <Button type="primary" size="large" onClick={scenarioAdd}>
            Create Scenario
          </Button>
        </div>
      </div>
    </div>
  );
};
